import { LinkItem, Page, useAppLayoutContextConsumer } from '@occc-app/design-system';

import { ConfigureForm } from '../messaging-campaign-configure/components/configure-form/configure-form.component';
import { MessagingCampaignConfigureFormProps } from '../messaging-campaign-configure/components/configure-form/configure-form.types';
import { MessagingCampaignConfigureLayout } from '../messaging-campaign-configure/messaging-campaign-configure.layout';
import { MessagingCampaignTabs } from '../messaging-campaign-configure/messaging-campaign-configure.constants';
import { CONFIGURE_PAGE_SUBTITLE, PAGE_TITLE } from '../../messaging-center.constants';

type MessagingCampaignCreatePageProps = {
  configureFormProps: MessagingCampaignConfigureFormProps;
  breadcrumbLinks: LinkItem[];
  isLoading: boolean;
};

export const MessagingCampaignCreatePage = ({
  configureFormProps,
  breadcrumbLinks,
  isLoading,
}: MessagingCampaignCreatePageProps) => {
  useAppLayoutContextConsumer(breadcrumbLinks);

  return (
    <Page
      browserTabTitle={PAGE_TITLE}
      containerProps={{ variant: 'md' }}
      pageHeaderProps={{ title: PAGE_TITLE, subtitle: CONFIGURE_PAGE_SUBTITLE }}
    >
      <MessagingCampaignConfigureLayout
        title={PAGE_TITLE}
        subtitle={CONFIGURE_PAGE_SUBTITLE}
        selectedTab={MessagingCampaignTabs.Configure}
        loading={isLoading}
        tabs={[
          { value: MessagingCampaignTabs.Configure, label: 'Configure' },
          // Target and Schedule tabs are disabled on the Create page, as they become
          // relevant only after the initial configuration is saved and a campaign is created
          { value: MessagingCampaignTabs.Target, label: 'Target', disabled: true },
          { value: MessagingCampaignTabs.Schedule, label: 'Schedule & Finalize', disabled: true },
        ]}
      >
        <ConfigureForm {...configureFormProps} />
      </MessagingCampaignConfigureLayout>
    </Page>
  );
};
